import * as React from "react";
import { Component } from "react";
import {
  Button,
  Checkbox,
  Col,
  ControlLabel,
  Form,
  FormControl,
  FormGroup,
  Radio,
} from "react-bootstrap";
import "src/css/components/projects/projectsettings.css";
import { IProjectSettingsProps, IProjectSettingsState } from "./interfaces";

export default class ProjectSettings extends Component<
  IProjectSettingsProps,
  IProjectSettingsState
> {
  public constructor(props: IProjectSettingsProps) {
    super(props);

    this.state = {
      loading: true,
    };

    this.handleUseSimplifiedStatementChanged = this.handleUseSimplifiedStatementChanged.bind(this);
    this.handleRateTypeChanged = this.handleRateTypeChanged.bind(this);
    this.saveSettings = this.saveSettings.bind(this);
    this.handleCancel = this.handleCancel.bind(this);
    this.handleCheckEstimatedGenerationChanged = this.handleCheckEstimatedGenerationChanged.bind(
      this
    );
    this.handleAllowStatementUploadChanged = this.handleAllowStatementUploadChanged.bind(this);
    this.handleAllowStatementParsingChanged = this.handleAllowStatementParsingChanged.bind(this);
    this.editStatementTemplates = this.editStatementTemplates.bind(this);
    this.handlePriorDataEditableChanged = this.handlePriorDataEditableChanged.bind(this);
    this.locationChanged = this.locationChanged.bind(this);
  }

  public componentDidMount() {
    this.setState({ loading: false });
  }

  public render() {
    return (
      <div className="column">
        <Form onSubmit={this.saveSettings}>
          <fieldset>
            <legend>Project Location</legend>
            <FormGroup
              bsSize="small"
              controlId="projectLocation"
              style={{ padding: "0px", margin: "0px" }}
            >
              <Col xs={3} sm={3} md={3} componentClass={ControlLabel}>
                Location
              </Col>
              <Col xs={9} sm={9} md={9}>
                <FormControl
                  bsSize="small"
                  type="text"
                  value={this.props.location}
                  onChange={this.locationChanged}
                />
              </Col>
            </FormGroup>
          </fieldset>
          <fieldset className="fieldset-settings">
            <legend>Statement Settings</legend>
            <Checkbox
              checked={this.props.useSimplifiedStatement}
              onChange={this.handleUseSimplifiedStatementChanged}
              inline={false}
            >
              Use Simplified Statement
            </Checkbox>
            <FormGroup controlId="rateType">
              <Radio
                value={0}
                name="rateType"
                inline={true}
                checked={this.props.rateType === 0}
                onChange={this.handleRateTypeChanged}
              >
                Single Rate
              </Radio>
              <Radio
                value={1}
                name="rateType"
                inline={true}
                checked={this.props.rateType === 1}
                onChange={this.handleRateTypeChanged}
              >
                Dual Rate
              </Radio>
              <Checkbox
                checked={this.props.priorDataEditable}
                disabled={this.props.useSimplifiedStatement}
                onChange={this.handlePriorDataEditableChanged}
                inline={false}
              >
                Allow Editing of Prior Data
              </Checkbox>
              <Checkbox
                checked={this.props.allowStatementUpload}
                onChange={this.handleAllowStatementUploadChanged}
                inline={false}
              >
                Allow Statement Upload
              </Checkbox>
              <Checkbox
                checked={this.props.allowStatementParsing}
                onChange={this.handleAllowStatementParsingChanged}
                inline={false}
              >
                Allow Statement Parsing
              </Checkbox>
            </FormGroup>
          </fieldset>
          <fieldset className="fieldset-settings">
            <legend>Report Settings</legend>
            <Checkbox
              checked={this.props.checkEstimatedGeneration}
              onChange={this.handleCheckEstimatedGenerationChanged}
              inline={false}
            >
              Check Estimated Generation
            </Checkbox>
          </fieldset>
          <fieldset>
            <legend>Statement Templates</legend>
            <Button bsSize="small" bsStyle="success" onClick={this.editStatementTemplates}>
              Statement Templates
            </Button>
          </fieldset>
          <Button
            type="submit"
            bsStyle="primary"
            bsSize="small"
            className="button-right button-top"
            onClick={this.saveSettings}
          >
            Save
          </Button>
          <Button
            bsStyle="danger"
            bsSize="small"
            onClick={this.handleCancel}
            className="button-top"
          >
            Cancel
          </Button>
        </Form>
      </div>
    );
  }

  private handleUseSimplifiedStatementChanged(e: any) {
    const priorDataEditable: boolean = e.target.checked ? false : this.props.priorDataEditable;
    this.props.handleUseSimplifiedStatementChanged(e.target.checked);
    this.props.handlePriorDataEditableChanged(priorDataEditable);
  }
  private handleCheckEstimatedGenerationChanged(e: any) {
    this.props.handleCheckEstimatedGenerationChanged(e.target.checked);
  }
  private handleRateTypeChanged(e: any) {
    this.props.handleRateTypeChanged(Number(e.target.value));
  }
  private handleAllowStatementUploadChanged(e: any) {
    this.props.handleAllowStatementUploadChanged(e.target.checked);
  }
  private handleAllowStatementParsingChanged(e: any) {
    this.props.handleAllowStatementParsingChanged(e.target.checked);
  }
  private saveSettings(e: any) {
    e.preventDefault();
    this.props.saveSettings(
      this.props.location,
      this.props.useSimplifiedStatement,
      this.props.rateType,
      this.props.checkEstimatedGeneration,
      this.props.allowStatementUpload,
      this.props.allowStatementParsing,
      this.props.priorDataEditable
    );
  }
  private handleCancel(e: any) {
    e.preventDefault();
    this.props.handleCancel();
  }
  private editStatementTemplates(e: any) {
    e.preventDefault();
    this.props.history.push(`/statementTemplates/${this.props.appService.getActiveProjectId()}`);
  }
  private handlePriorDataEditableChanged(e: any) {
    this.props.handlePriorDataEditableChanged(e.target.checked);
  }
  private locationChanged(e: any) {
    this.props.locationChanged(e.target.value);
  }
}



// WEBPACK FOOTER //
// ./src/components/projects/ProjectSettings.tsx